angular.module('impactx.productcoding').controller('ProductCodeDummyListCtrl',  [
    'selectedListItems',
    ProductCodeDummyListCtrl]);

function ProductCodeDummyListCtrl(selectedListItems)
{
    var ctrl = this;

    this.getDetailLink = function() {
        return "prcodedummy/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ProductCodingDummy'}
    ];

    this.meta = {
        rowTemplate: 'modules/productcoding/templates/prcodedummylist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/productcoding/dummy/list',
        id: 'productcodingdummylist',
        buttonDefinition: buttonDefinition,
        mainAction: {id: "new", link: "#/prcodedummy/0", icon: "mdi-plus"},
    };

    this.getMeta = function () {
        return this.meta;
    };
}